import {Command} from "./Command";
import {GamePlay} from "../model/game-play";

export class RepeatLastDownCommand implements Command {
  constructor(
    private gamePlay: GamePlay,
    private lastGamePlay: GamePlay
  ) { }

  execute() {
    console.log('COMMAND RepeatLastDownCommand', this.lastGamePlay.down)
    this.gamePlay.down = this.lastGamePlay.down
  }
}
